import React, { Fragment, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../layout/header";
import Footer from "../../layout/footer";
import { Card, Col, Container, Row } from "react-bootstrap";
import ResumeCard from "./resumcard";
import { apiCall } from "utils/httpClient";
import apiEndPoint from "utils/apiEndPoint";
import { failedMessage } from "utils/httpClient";
import { loadFromLocalStorage } from "utils/LocalStorageUtils";

function Enquires() {
  const [enquiresList, setEnquiresList] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [isLoading, setLoading] = useState(true);
  const [languageData, setLanguageData] = useState(null);
  const selectLang = loadFromLocalStorage("SELECTLANGUAGE");
  useEffect(() => {
    setLanguageData(selectLang?.language)
  }, [selectLang])

  useEffect(() => {
    getEnquiresList();
  }, [currentPage]);

  const getEnquiresList = async () => {
    let params = { limit: 6, offset: currentPage === 0 ? 0 : currentPage - 1 }
    const { data } = await apiCall("post", apiEndPoint.GETUSERMESSAGELIST, params);
    if (data.status === 200) {
      setEnquiresList(data.data);
      setTotalPages(Math.ceil(data?.total_data / 6));
    } else {
      setEnquiresList([]);
      failedMessage(data.message);
    }
    setLoading(false)
  };
  return (
    <Fragment>
      <div className="services-section mt-5">
        <div className="container text-center">
          <h3 className="animate__animated animate__bounce" style={{ fontFamily: 'quicksand', fontWeight: 600, textAlign: 'center', margin: 'auto' }}>
            {languageData?.enquires}
          </h3>
          <br />
          <p style={{ fontSize: 16, fontWeight: 600, maxWidth: 800, margin: 'auto', color: '#444' }}>
            {languageData?.manageAllYourInquiresReceived}
          </p>
        </div>
      </div>
      <Container className="">
        <div className="card mt-5">
          <Card className="m-3">
            {enquiresList.length > 0 && enquiresList.map((item, i) => (
              <Row noGutters style={{ alignItems: 'center' }}>
                <Col md={6}>
                  <div className="p-3">
                    <p className="mb-1"><strong>{languageData?.enquiry} {i + 1}</strong></p>
                  <p className="mb-1"><strong>{languageData?.name}</strong> : {item?.user_name}</p>
                    <p className="mb-1"><strong>{languageData?.mobileNo}</strong> : {item?.mobile}</p>
                    <p className="mb-1"><strong>{languageData?.email}</strong> : {item?.email}</p>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="p-3">
                    <p className="mb-1"><strong>{languageData?.message} :</strong> {item?.message}</p>
                  </div>
                </Col>
              </Row>
            ))}
          </Card>
        </div>
      </Container>
    </Fragment>
  );
}

export default Enquires;